import { render, staticRenderFns } from "./add-emergency.vue?vue&type=template&id=aef3188c&scoped=true"
import script from "./add-emergency.vue?vue&type=script&lang=js"
export * from "./add-emergency.vue?vue&type=script&lang=js"
import style0 from "./add-emergency.vue?vue&type=style&index=0&id=aef3188c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef3188c",
  null
  
)

export default component.exports